import { render } from "./TransporterProfile.vue?vue&type=template&id=12ba70af&scoped=true"
import script from "./TransporterProfile.vue?vue&type=script&lang=js"
export * from "./TransporterProfile.vue?vue&type=script&lang=js"

import "./TransporterProfile.vue?vue&type=style&index=0&id=12ba70af&lang=css"
import "./TransporterProfile.vue?vue&type=style&index=1&id=12ba70af&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ba70af"]])

export default __exports__